import { type ReactNode, type CSSProperties } from 'react'
import cl from 'clsx'

export type TableColumnDescription<Key extends string> = {
    key: Key
    width: number
    sticky?: boolean
}

const TABLE_COLUMN_STICKY_CLASS = 'sticky z-20'
const TABLE_COLUMN_NON_STICKY_CLASS = ''
const TABLE_COLUMN_PADDING = 4
const TABLE_COLUMN_PADDING_CLASS = 'px-1'
const TABLE_COLUMN_PADDING_LEFT_CLASS = 'pl-1'
const TABLE_COLUMN_PADDING_RIGHT_CLASS = 'pr-1'

export const makeTableColumnsLayout = <Key extends string>(
    tableColumnsOrder: readonly TableColumnDescription<Key>[]
) => {
    let left = 0

    const result: {
        key: Key
        style: CSSProperties
        className: string
    }[] = []
    tableColumnsOrder.forEach((column, index) => {
        const isSticky = 'sticky' in column && column.sticky

        let width: number
        let paddingClassName: string

        if (index === 0) {
            width = column.width + TABLE_COLUMN_PADDING
            paddingClassName = TABLE_COLUMN_PADDING_RIGHT_CLASS
        } else if (index === tableColumnsOrder.length - 1) {
            width = column.width + TABLE_COLUMN_PADDING
            paddingClassName = TABLE_COLUMN_PADDING_LEFT_CLASS
        } else {
            width = column.width + TABLE_COLUMN_PADDING * 2
            paddingClassName = TABLE_COLUMN_PADDING_CLASS
        }

        result.push({
            key: column.key,
            className: cl(
                paddingClassName,
                isSticky
                    ? TABLE_COLUMN_STICKY_CLASS
                    : TABLE_COLUMN_NON_STICKY_CLASS
            ),
            style: {
                width,
                minWidth: width,
                maxWidth: width,
                ...(isSticky
                    ? {
                          left,
                      }
                    : {}),
            },
        })
        left += width
    })

    return result
}

export type TableRecord<Key extends string> = Record<Key, ReactNode>
